export const trackEvent = (eventName: string, eventData?: object) => {
  // Ensure dataLayer is defined
  window.dataLayer = window.dataLayer || [];

  // Push event to GTM dataLayer
  window.dataLayer.push({
    event: eventName,
    ...eventData, // Merge the custom event data
  });

  console.log(`${eventName} event pushed to GTM`, eventData);
};
